<template>
  <div>
    <router-view />
    <SplashScreen v-if="!isTravelRoute && !isTravelSplashActive" />
  </div>
</template>

<script>
import SplashScreen from './views/SplashScreen.vue';

export default {
  components: {
    SplashScreen,
  },
  data() {
    return {
      isTravelSplashActive: false,
    };
  },
  computed: {
    isTravelRoute() {
      return this.$route.path === '/travel';
    },
  },
  watch: {
    isTravelRoute(newVal) {
      // Hide main splash when on travel route
      if (newVal) {
        this.isTravelSplashActive = true;
      } else {
        this.isTravelSplashActive = false;
      }
    },
  },
  mounted() {
    // Check if we're on travel route on mount
    if (this.isTravelRoute) {
      this.isTravelSplashActive = true;
    }
  },
};
</script>

<style>
html,
body {
  background: #ffffff;
}
#app {
  font-family: 'AirbnbCereal_W_Bk';
  -webkit-font-smoothing: antialiased;
  background: #ffffff;
}
</style>
